import React, { useEffect, useMemo, useState } from "react";
import { Select, Tooltip, Slider, InputNumber } from "antd";
import {
  setChartYaxisSettingsData,
  setChartYaxisScale,
  setWidgetGlobalStackedToDisabled,
  setChartYAxisMapAt,
  setChartYAxisMode,
  setLineProperty,
  setChartMedianAtYAxis,
  setChartMedianStaticAtYAxis,
} from "../../../redux/actions/WidgetMaker/GraphConfig";
import { useDispatch, useSelector } from "react-redux";
import accoArrow from "../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { callNotification, isValidNumber } from "../../../redux/constants";
import { LineStyles } from "../../../redux/constants/enums";
import useDebounce from "../../layout/WelcomePage/Worksheets/useDebounce";
import Checkbox from "antd/lib/checkbox";
const { Option } = Select;

const AxisSetting = ({ yAxis, listIndex }) => {
  const dispatch = useDispatch();
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const authParams = useSelector((state) => state.Authentication.authParams);

  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const combinationGraphData = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );
  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const widgetMakerGraphData1 = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );
  const [chartConfig, setChartConfig] = useState({
    lineStyle:
      widgetGraphConfig?.y_axis_settings?.[listIndex]?.lineStyle || "Solid",
    lineWidth: widgetGraphConfig?.y_axis_settings?.[listIndex]?.lineWidth || 3,
    listIndex: listIndex,
  });
  // Set initial config; default min=1, max=5
  const initialMedian = widgetGraphConfig?.y_axis_settings?.[listIndex]?.median;
  const [medianConfig, setMedianConfig] = useState({
    min: 1,
    max: 5,
    value: initialMedian ?? null, // default to min if undefined
  });
  const [previousValueOfStaicMedian, setPreviousValueOfStaicMedian] =
    useState(false);
  const debouncedMedianConfig = useDebounce(medianConfig, 500); // for adding some delay
  const [showErrorMessageForMedian, setShowErrorMessageForMedian] =
    useState(false);

  const widgetMakerGraphData = useMemo(() => {
    return typeof widgetMakerGraphData1 === "string"
      ? widgetMakerGraphData1
      : widgetMakerGraphData1?.data?.[
          widgetGraphConfig?.chart_type === "combination"
            ? "combination"
            : widgetGraphConfig?.chart_type === "horizontal-bar"
            ? "bar"
            : widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type
        ];
  }, [widgetMakerGraphData1]);

  useEffect(() => {
    // console.log(
    //   "initialMedian : ",
    //   initialMedian,
    //   "widgetMakerGraphData : ",
    //   widgetMakerGraphData,
    //   "listIndex : ",
    //   listIndex
    // );
    let maxOfXCategories = 5;
    if (widgetMakerGraphData) {
      if (Array.isArray(widgetMakerGraphData?.x)) {
        let xAxisCategoriesValues = widgetMakerGraphData?.x?.map((el, i) => {
          return Math.round(parseFloat(el) * 100) / 100;
        });
        maxOfXCategories = xAxisCategoriesValues
          ? Math.max(...xAxisCategoriesValues)
          : 5;
      }
    }
    let maxLimit =
      listIndex === 0 && maxOfXCategories >= 0 // if List index is 0 that means, this is for x_median
        ? maxOfXCategories
        : null;
    if (initialMedian) {
      setMedianConfig((prev) => ({
        ...prev,
        value:
          listIndex === 1 &&
          !widgetGraphConfig?.y_axis_settings?.[listIndex]?.is_median_static &&
          widgetMakerGraphData?.medians?.y_median
            ? widgetMakerGraphData?.medians?.y_median
            : initialMedian,
        max: maxLimit,
      }));
    } else {
      if (widgetMakerGraphData?.medians) {
        let medians = widgetMakerGraphData?.medians;
        if (listIndex === 0) {
          // if List index is 0 that means, this is for x_median
          setMedianConfig((prev) => ({
            ...prev,
            value: medians?.x_median,
            max: maxLimit,
          }));
        } else if (listIndex === 1) {
          // if List index is 1 that means, this is for y_median
          setMedianConfig((prev) => ({
            ...prev,
            value: medians?.y_median,
            max: maxLimit,
          }));
        }
      }
    }
    if (listIndex === 1 && widgetMakerGraphData?.medians) {
      let y_axes_settings = widgetGraphConfig?.y_axis_settings?.[listIndex];
      // If anyone has is_median_static true then set it to true
      // else set it to false
      let valueOfStaicMedian =
        typeof y_axes_settings?.is_median_static === "boolean"
          ? y_axes_settings?.is_median_static
          : false;
      // If valueOfStaicMedian is false and previousValueOfStaicMedian is true then set refresh value to true
      // For after calling api to get updated median
      if (!valueOfStaicMedian && previousValueOfStaicMedian) {
        let medians = widgetMakerGraphData?.medians;
        setMedianConfig((prev) => ({
          ...prev,
          value: medians?.y_median,
        }));
        setPreviousValueOfStaicMedian(valueOfStaicMedian);
      } else {
        setPreviousValueOfStaicMedian(valueOfStaicMedian);
      }
    }
  }, [initialMedian, widgetMakerGraphData]);
  useEffect(() => {
    if (
      debouncedMedianConfig &&
      debouncedMedianConfig?.value !== null &&
      !showErrorMessageForMedian
    ) {
      if (
        debouncedMedianConfig?.value >= debouncedMedianConfig?.min &&
        (debouncedMedianConfig?.max !== null
          ? debouncedMedianConfig?.value <= debouncedMedianConfig?.max
          : true)
      ) {
        // console.log(
        //   "\n\n\n ***************** Valid value : ",
        //   debouncedMedianConfig?.value,
        //   "listIndex : ",
        //   listIndex
        // );
        let updateYAxisSettingWithMedian = widgetGraphConfig?.y_axis_settings;
        let list = [...updateYAxisSettingWithMedian];
        let index = list.findIndex((el, index) => index === listIndex);
        list[index].median = debouncedMedianConfig?.value;
        dispatch(
          setChartMedianAtYAxis(
            list,
            widgetGraphConfig,
            widgetGraphConfig?.chart_type
          )
        );
      }
    }
  }, [debouncedMedianConfig]);
  useEffect(() => {
    setChartConfig({
      lineStyle: "Solid",
      lineWidth: 3,
      listIndex: listIndex,
    });
  }, [listIndex]);
  const handleYAxisChartType = (value, i) => {
    let updateCombinationGraphData = combinationGraphData;
    let list = [...updateCombinationGraphData?.data["combination"]["y_axis"]];
    let index = list.findIndex((el, index) => index === i);
    list[index].chart_type = value;

    //check for all series have same chart type
    let sameShowAsExists = true;
    let typeOfG1 = list?.[0]?.chart_type;
    list?.forEach((ls) => {
      if (ls?.chart_type !== typeOfG1) {
        sameShowAsExists = false;
      }
    });
    dispatch(
      setWidgetGlobalStackedToDisabled(sameShowAsExists, widgetGraphConfig)
    );

    dispatch(setChartYaxisSettingsData(list, widgetGraphConfig));
  };
  const handleLinePropertyChange = (property, newValue, listIndex) => {
    setChartConfig((prevConfig) => ({
      ...prevConfig,
      [property]: newValue,
    }));

    dispatch(
      setLineProperty(
        {
          ...widgetGraphConfig.y_axis_settings[listIndex],
          [property]: newValue,
        },
        widgetGraphConfig,
        listIndex
      )
    );
  };
  const handleYAxisScale = (value, i) => {
    if (widgetGraphConfig?.chart_type !== "combination") {
      dispatch(
        setChartYaxisScale(
          value,
          widgetGraphConfig,
          widgetGraphConfig?.chart_type
        )
      );
    } else {
      let updateCombinationGraphData = combinationGraphData;
      let list = [...updateCombinationGraphData?.data["combination"]["y_axis"]];
      list =
        Array.isArray(list) &&
        list?.map((l) => {
          l.y_axis_scale = l?.y_axis_scale ? l?.y_axis_scale : "linear";
          return l;
        });
      let index = list.findIndex((el, index) => index === i);
      list[index].y_axis_scale = value;
      let yAxisModeSettingUpdate = false;
      let scaleOfG1 = list?.[0].y_axis_scale ? list?.[0].y_axis_scale : null;
      for (let e = 0; e < list?.length; e++) {
        if (!scaleOfG1 && list?.[e]?.y_axis_scale) {
          scaleOfG1 = list?.[e]?.y_axis_scale;
        } else if (
          scaleOfG1 &&
          list?.[e]?.y_axis_scale &&
          scaleOfG1 !== list?.[e]?.y_axis_scale
        ) {
          yAxisModeSettingUpdate = true;
          break;
        }
      }
      // need to reset y axis mode to dual axis mode
      if (
        yAxisModeSettingUpdate &&
        widgetGraphConfig?.chart_property?.y_axis_mode == "1"
      ) {
        callNotification(
          "Y-axis mode changed to dual axis for better visualization",
          "info"
        );
        dispatch(setChartYAxisMode("2", widgetGraphConfig));
      }

      dispatch(
        setChartYaxisScale(
          list,
          widgetGraphConfig,
          widgetGraphConfig?.chart_type
        )
      );
    }
  };
  const handleYAxisMapAt = (value, i) => {
    if (widgetGraphConfig?.chart_type !== "combination") {
      dispatch(
        setChartYAxisMapAt(
          value,
          widgetGraphConfig,
          widgetGraphConfig?.chart_type
        )
      );
    } else {
      let updateCombinationGraphData = widgetGraphConfig?.y_axis_settings;
      let list = [...updateCombinationGraphData];
      let index = list.findIndex((el, index) => index === i);
      list[index].y_axis_map_at = value;
      dispatch(
        setChartYAxisMapAt(
          list,
          widgetGraphConfig,
          widgetGraphConfig?.chart_type
        )
      );
    }
  };

  const handleChangeMedianLimit = (value, index) => {
    // console.log("handleChangeMedianLimit : ", value, index);
    let newValue = value;
    // Allow null (empty) input with triggering error immediately
    if (newValue === null) {
      setMedianConfig((prev) => ({ ...prev, value: null }));
      setShowErrorMessageForMedian(true);
      return;
    }
    if (medianConfig && isValidNumber(newValue)) {
      setMedianConfig((prevConfig) => ({
        ...prevConfig,
        value: newValue,
      }));
      if (
        newValue >= medianConfig?.min &&
        (medianConfig?.max !== null ? newValue <= medianConfig?.max : true)
      ) {
        setShowErrorMessageForMedian(false);
      } else {
        setShowErrorMessageForMedian(true);
      }
    } else {
      setShowErrorMessageForMedian(true);
    }
  };
  const handleChangeMedianLimitStatic = (event, listIndex) => {
    // console.log("handleChangeMedianLimitStatic : ", listIndex);
    let value = event?.target?.value;
    let isChecked = event?.target?.checked;
    // console.log("isChecked : ", isChecked, "value : ", value);

    if (value === "StaticMedian") {
      let updateYAxisSettingWithMedian = widgetGraphConfig?.y_axis_settings;
      let list = [...updateYAxisSettingWithMedian];
      let index = list.findIndex((el, index) => index === listIndex);
      list[index].is_median_static = isChecked;
      let medianValue;
      if (widgetMakerGraphData?.medians && !isChecked) {
        let medians = widgetMakerGraphData?.medians;
        if (listIndex === 0) {
          // if List index is 0 that means, this is for x_median
          medianValue = medians?.x_median;
          setMedianConfig((prev) => ({
            ...prev,
            value: medians?.x_median,
          }));
        } else if (listIndex === 1) {
          // if List index is 1 that means, this is for y_median
          medianValue = medians?.y_median;
          setMedianConfig((prev) => ({
            ...prev,
            value: medians?.y_median,
          }));
        }
      }
      if (medianValue) {
        list[index].median = medianValue;
      }
      dispatch(
        setChartMedianStaticAtYAxis(
          list,
          widgetGraphConfig,
          widgetGraphConfig?.chart_type
        )
      );
    }
  };
  return (
    <div>
      <div className="text_regular mb-15 mt-2">
        {widgetGraphConfig &&
        widgetGraphConfig?.y_axis &&
        widgetGraphConfig?.y_axis["y_series_" + (listIndex + 1)]
          ? widgetGraphConfig?.y_axis["y_series_" + (listIndex + 1)]?.trace_name
          : All_WM_attributes[
              widgetGraphConfig?.y_axis["y_series_" + (listIndex + 1)]
                ?.attribute
            ]}
      </div>

      {widgetGraphConfig?.chart_type === "scatter" ? (
        <>
          <Tooltip
            title={
              !widgetGraphConfig?.chart_settings?.show_as_median
                ? "Switch to quadrant mode to set median limit"
                : ""
            }
          >
            <div className="w-100 mb-3">
              {listIndex > 0 ? (
                <Checkbox
                  value="StaticMedian"
                  disabled={!widgetGraphConfig?.chart_settings?.show_as_median}
                  className="text_regular m-0 mb-2 d-flex align-items-start"
                  onChange={(e) => {
                    handleChangeMedianLimitStatic(e, listIndex);
                  }}
                  checked={
                    typeof widgetGraphConfig?.y_axis_settings?.[listIndex]
                      .is_median_static === "boolean"
                      ? widgetGraphConfig?.y_axis_settings?.[listIndex]
                          .is_median_static
                      : false
                  }
                >
                  Static Median
                </Checkbox>
              ) : (
                ""
              )}
              <div className="position-relative chartName floating-label-group mt-3">
                <InputNumber
                  required
                  id={`median_limit_in_series_${listIndex + 1}`}
                  //label="Limit"
                  //placeholder="Enter limit"
                  type="number"
                  min={medianConfig?.min}
                  // max={medianConfig?.max} // not using this because it is stoping onchange when reach max limit
                  value={medianConfig?.value}
                  onChange={(num) => {
                    handleChangeMedianLimit(num, listIndex);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // stringMode={true}
                  className="border-radius-4 border-color w-100"
                  autocompleteDisabled={true}
                  disabled={
                    !widgetGraphConfig?.chart_settings?.show_as_median
                      ? true
                      : listIndex > 0
                      ? widgetGraphConfig?.y_axis_settings?.[listIndex]
                          ?.is_median_static === true
                        ? false
                        : true
                      : false
                  }
                />
                <label
                  className="portlet-label floating-label"
                  htmlFor={`median_limit_in_series_${listIndex + 1}`}
                >
                  Median Limit
                  {/* <span className="error">*</span> */}
                </label>
              </div>
              {showErrorMessageForMedian ? (
                <div className="error position-absolute font-size12 error">
                  Enter a limit
                  {!medianConfig?.max
                    ? " greater than 0"
                    : `between ${medianConfig?.min} and ${medianConfig?.max}.`}
                </div>
              ) : (
                ""
              )}
            </div>
          </Tooltip>
        </>
      ) : (
        ""
      )}

      {widgetGraphConfig?.chart_type === "combination" && (
        <div className="floating-label-group header-brands mb-15">
          <Select
            placeholder="Show As"
            defaultValue={
              widgetGraphConfig?.y_axis_settings &&
              widgetGraphConfig?.y_axis_settings[listIndex]?.show_as
            }
            onChange={(e) => handleYAxisChartType(e, listIndex)}
            className="w-100 text_regular"
            dropdownClassName={
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }
            suffixIcon={
              <img
                src={
                  authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                }
                alt="acco Arrow"
                className="accordionArrow p-0"
              />
            }
          >
            <Option value="bar">Bar Chart</Option>
            <Option value="line">Line Chart</Option>
            <Option value="area">Area Chart</Option>
          </Select>
          <label
            className="portlet-label floating-label bg__white font-size12"
            style={{ top: "-0.8rem" }}
          >
            Show As
          </label>
        </div>
      )}
      {/* <Checkbox className="text_regular mb-15" onChange={selectAxisType}>Show Data Label</Checkbox> */}

      {listIndex === 0 &&
      (widgetGraphConfig?.chart_type === "bar" ||
        widgetGraphConfig?.chart_type === "horizontal-bar" ||
        widgetGraphConfig?.chart_type === "line" ||
        widgetGraphConfig?.chart_type === "area") ? (
        <>
          <div className="text_regular font-weight600 mb-1">
            Visualization Option
          </div>
          <div className="floating-label-group header-brands mb-15">
            <Tooltip
              title={
                graphConditions?.["time-label-attrs"]?.includes(
                  widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                    ?.attribute
                ) ||
                graphConditions?.["ticket-time-label-attrs"]?.includes(
                  widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                    ?.attribute
                )
                  ? "Logarithmic scale not compatible with FLR attributes"
                  : ""
              }
            >
              <Select
                className="w-100 text_regular"
                placeholder="Y-axis scale"
                defaultValue="linear"
                suffixIcon={
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? accoArrowWhite
                        : accoArrow
                    }
                    alt="acco Arrow"
                    className="accordionArrow p-0"
                  />
                }
                value={widgetGraphConfig?.y_axis_settings?.[0].y_axis_scale}
                onChange={(e) => handleYAxisScale(e, listIndex)}
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
                disabled={
                  graphConditions?.["time-label-attrs"]?.includes(
                    widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                      ?.attribute
                  ) ||
                  graphConditions?.["ticket-time-label-attrs"]?.includes(
                    widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                      ?.attribute
                  )
                }
              >
                <Option value="linear">Linear</Option>
                <Option value="log">Log</Option>
              </Select>
            </Tooltip>
            <label
              className="portlet-label floating-label bg__white font-size12"
              style={{ top: "-0.8rem" }}
            >
              Y-axis scale
            </label>
          </div>
        </>
      ) : (
        listIndex >= 0 &&
        listIndex <= 1 &&
        widgetGraphConfig?.chart_type === "combination" && (
          <>
            <div className="text_regular font-weight600 mb-1">
              Visualization Option
            </div>
            <div className="floating-label-group header-brands mb-15">
              <Tooltip
                title={
                  graphConditions?.["time-label-attrs"]?.includes(
                    widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                      ?.attribute
                  ) ||
                  graphConditions?.["ticket-time-label-attrs"]?.includes(
                    widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                      ?.attribute
                  )
                    ? "Logarithmic scale not compatible with FLR attributes"
                    : ""
                }
              >
                <Select
                  className="w-100 text_regular"
                  placeholder="Y-axis scale"
                  defaultValue="linear"
                  suffixIcon={
                    <img
                      src={
                        authParams?.theme_type === "1"
                          ? accoArrowWhite
                          : accoArrow
                      }
                      alt="acco Arrow"
                      className="accordionArrow p-0"
                    />
                  }
                  value={
                    widgetGraphConfig?.y_axis_settings?.[listIndex]
                      ?.y_axis_scale
                      ? widgetGraphConfig?.y_axis_settings?.[listIndex]
                          ?.y_axis_scale
                      : "linear"
                  }
                  onChange={(e) => handleYAxisScale(e, listIndex)}
                  dropdownClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                  disabled={
                    graphConditions?.["time-label-attrs"]?.includes(
                      widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                        ?.attribute
                    ) ||
                    graphConditions?.["ticket-time-label-attrs"]?.includes(
                      widgetGraphConfig?.y_axis?.["y_series_" + (listIndex + 1)]
                        ?.attribute
                    )
                  }
                >
                  <Option value="linear">Linear</Option>
                  <Option value="log">Log</Option>
                </Select>
              </Tooltip>

              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Y-axis scale
              </label>
            </div>
          </>
        )
      )}

      {/* Temporary Commented this feature */}
      {(widgetGraphConfig?.chart_type === "line" ||
        (widgetGraphConfig?.y_axis_settings[listIndex]?.show_as === "line" &&
          ![
            "bar",
            "lollipop",
            "horizontal-bar",
            "area",
            "areaspline",
            "scatter",
            "multilayer-map",
          ]?.includes(widgetGraphConfig?.chart_type))) && (
        <>
          <div className="floating-label-group header-brands mb-15">
            <Tooltip title="Choose the line style for the chart.">
              <Select
                className="w-100 text_regular"
                placeholder="Line Style"
                defaultValue="solid"
                suffixIcon={
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? accoArrowWhite
                        : accoArrow
                    }
                    alt="acco Arrow"
                    className="accordionArrow p-0"
                  />
                }
                value={
                  widgetGraphConfig?.y_axis_settings?.[listIndex]?.lineStyle ||
                  "solid"
                }
                onChange={(value) =>
                  handleLinePropertyChange("lineStyle", value, listIndex)
                }
                popupClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                {Object.keys(LineStyles).map((key) => (
                  <Select.Option key={key} value={key}>
                    {LineStyles[key]}
                  </Select.Option>
                ))}
              </Select>
            </Tooltip>
            <label
              className="portlet-label floating-label bg__white font-size12"
              style={{ top: "-0.8rem" }}
            >
              Line Style
            </label>
          </div>
          <div className="mb-15">
            <label htmlFor="lineWidth" className="font-size12">
              Line Width:
            </label>
            <Slider
              min={2}
              max={8}
              step={1}
              value={
                widgetGraphConfig?.y_axis_settings?.[listIndex].lineWidth || 3
              }
              onChange={(value) =>
                handleLinePropertyChange("lineWidth", value, listIndex)
              }
            />
          </div>
        </>
      )}

      {widgetGraphConfig?.chart_type === "combination" &&
        widgetGraphConfig?.chart_property?.y_axis_mode == 2 &&
        !graphConditions?.["time-label-attrs"]?.includes(
          widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ) && (
          <>
            <div className="floating-label-group header-brands mb-15">
              <Select
                className="w-100 text_regular"
                placeholder="Y-axis"
                defaultValue={
                  widgetGraphConfig?.y_axis_settings &&
                  widgetGraphConfig?.y_axis_settings[listIndex]?.y_axis_map_at
                }
                suffixIcon={
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? accoArrowWhite
                        : accoArrow
                    }
                    alt="acco Arrow"
                    className="accordionArrow p-0"
                  />
                }
                value={
                  widgetGraphConfig?.y_axis_settings?.[listIndex]?.y_axis_map_at
                    ? widgetGraphConfig?.y_axis_settings?.[listIndex]
                        ?.y_axis_map_at
                    : 0
                }
                onChange={(e) => handleYAxisMapAt(e, listIndex)}
                dropdownClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Option value={0}>Y-axis 1</Option>
                <Option value={1}>Y-axis 2</Option>
              </Select>
              <label
                className="portlet-label floating-label bg__white font-size12"
                style={{ top: "-0.8rem" }}
              >
                Y-axis position
              </label>
            </div>
          </>
        )}
      <label className="blue-text cursor-pointer d-none">
        Reset All Colors
      </label>
    </div>
  );
};

export default AxisSetting;
